import React, { useState, useEffect } from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import SemiModal from "../semi-modal";
import InputRadioButton from "../../shared/input-radio-button";
import Button from "../../shared/button";
import TransparentButton from "../../shared/button/transparent-button";
import { sendCustomGaEvents } from "../../../tracking";
import Pancard from "./images/panCard.png";
import AadhaarCard from "./images/aadhaar.png";
import RcCard from "./images/rcCard.png";
import { DIY_THIRD_PARTY_STATES } from "../post-inspection-diy/constant";
import { mismatchedOptionSelection, mismatchedPageView } from "./tracking";

const MissMatchSemiModal = ({
    token,
    misMatchDetails,
    close,
    appointmentId,
    consentOptions = [],
    verifyEkycDocumentConnect = () => {},
    diyPaymentApprovalProcessConnect = () => {},
    handlePostConfirmation = () => {},
    isLoading,
    setIsLoading
}) => {
    const applicableStatesForConsentOptions = [
        DIY_THIRD_PARTY_STATES.NOT_MATCHED
    ];

    const {
        nameOnDocument,
        ownerNameOnRc,
        transactionStatus = "",
        docType = "",
        docCode = "",
        gaEventType = "",
        gaEventCategory = "",
        isAadhaar
    } = misMatchDetails;

    const [consent, setConsent] = useState("");
    const isPartialMatch = transactionStatus === DIY_THIRD_PARTY_STATES.PARTIALLY_MATCHED;
    const misMatchType = isPartialMatch ? "Partial mismatch" : "full mismatch";

    useEffect(() => {
        if (appointmentId) {
            sendCustomGaEvents({
                ...mismatchedPageView,
                eventAction: `${gaEventType} ${misMatchType} pop-up view`,
                eventLabel: appointmentId,
                eventCategory: gaEventCategory
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appointmentId]);

    const onClose = () => {
        close();
    };

    const onClickConfirm = () => {
        setIsLoading(true);
        const payload = {
            docCode,
            ...(
                applicableStatesForConsentOptions.includes(transactionStatus) &&
                    consent && consent.key && {
                    consent: consent.key
                }
            )
        };
        verifyEkycDocumentConnect(token, payload).then(() => {
            diyPaymentApprovalProcessConnect(token).then((response) => {
                handlePostConfirmation(response);
                setIsLoading(false);
                close();
            });
        }).catch(() => { setIsLoading(false); });

    };

    const onChangeHandler = (item) => {
        sendCustomGaEvents({
            ...mismatchedOptionSelection,
            eventAction: `${gaEventType} ${item.eventLabel}`,
            eventLabel: appointmentId,
            eventCategory: gaEventCategory
        });
        setConsent(item);
    };

    const getBtnDisableState = () => !consent && applicableStatesForConsentOptions.includes(transactionStatus);

    const renderOptions = () => (
        consentOptions.map((item, index) => {
            return (
                <div
                    key={index}
                    styleName={`styles.paymentCheck ${consent === item ? "styles.paymentCheckActive" : ""}`}
                    onClick={() => onChangeHandler(item)}
                >
                    <InputRadioButton
                        checked={consent === item}
                        id={item.title}
                        text={item.title}
                        subText={item.subTitle}
                        isRevamped={true}
                    />
                </div>
            );
        })
    );

    return (
        <SemiModal>
            <div styleName={"styles.modalWrap"}>
                <div styleName={"styles.header"}>
                    <h6>Name on RC and {docType} do not match</h6>
                </div>
                <div styleName={"styles.userPanCard"}>
                    <div>
                        <h4>Name on {docType}</h4>
                        <span>{nameOnDocument}</span>
                    </div>
                    <img src={isAadhaar ? AadhaarCard : Pancard} alt="ekyc doc" width="60px" />
                </div>
                <div styleName={"styles.userRcCard"}>
                    <div>
                        <h4>Name on RC</h4>
                        <span>{ownerNameOnRc}</span>
                    </div>
                    <img src={RcCard} alt="pan card" width="60px" />
                </div>
                {
                    applicableStatesForConsentOptions.includes(transactionStatus) &&
                    <React.Fragment>
                        <h4 styleName="styles.tellusTitle">Please tell us why</h4>
                        {renderOptions()}
                    </React.Fragment>
                }
                <div styleName="styles.ctaWrapper">
                    <div styleName={"styles.transparentCta"}>
                        <TransparentButton
                            onClick={onClose}
                            text={"RETRY"}
                        />
                    </div>
                    <div styleName={"styles.otherAcc"}>
                        <Button
                            disabled={getBtnDisableState()}
                            onClick={onClickConfirm}
                            text={"CONFIRM"}
                            isLoading={isLoading}
                        />
                    </div>
                </div>
            </div>
        </SemiModal>
    );
};

MissMatchSemiModal.propTypes = {
    token: PropTypes.string,
    misMatchDetails: PropTypes.object,
    close: PropTypes.any,
    appointmentId: PropTypes.any,
    consentOptions: PropTypes.array,
    verifyEkycDocumentConnect: PropTypes.func,
    diyPaymentApprovalProcessConnect: PropTypes.func,
    handlePostConfirmation: PropTypes.func,
    isLoading: PropTypes.bool,
    setIsLoading: PropTypes.func
};
export default MissMatchSemiModal;

